import React from "react";
import { Outlet } from "react-router-dom";
import { CustomLayout } from "../components";

const LayoutHome = () => {
    return (
        <CustomLayout>
            <Outlet />
        </CustomLayout>
    );
};

export default LayoutHome;
